import { BizAppConfig } from 'config/application.manifest';
import { createRequest } from '@/services/request';
import type { AuthorizedResource } from '@/permissions/adapter';
import type { ApiRequestOptions } from './types/common';

const request = createRequest(BizAppConfig.appTenantManagementUrl);

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  return request<AuthorizedResource[]>('/bff/permission/me/authorized-resources', {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });
}
